<!--suppress AngularNgOptimizedImage, JSUnresolvedReference -->
<div class="d-flex w-100 align-items-center justify-content-center flex-column">
  <div class="logo">
    <img src="/views/getlogo/" alt="logo" />
  </div>
  @if (luser | async; as user) {
    <div class="welcome">
      <span class="fw-lighter text-secondary" i18n>Welcome</span
      ><span class="fw-light text-primary"> {{ user.firstname }} {{ user.lastname }}</span>
    </div>
  }
</div>
